import jQuery from "jquery"

global.$ = window.jQuery = jQuery
